module.exports = __webpack_public_path__ + "img/IMG_0208.3abc369f.jpg";